"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTempMomentForFileUpload = void 0;

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Brian Bal
 */
var createTempMomentForFileUpload = function createTempMomentForFileUpload(url) {
  return {
    event_number: 1,
    full_game_time: 0,
    game_clip_id: -1,
    game_id: -1,
    team_id: -1,
    start_time: 0,
    base_path: null,
    duration: 30,
    half: 1,
    time: 0,
    title: "Uploaded Moment",
    type: "custom",
    start_third: "defensive",
    end_third: "defensive",
    dynamic_audio: "",
    dynamic_duration: 30,
    dynamic_hls: "",
    dynamic_jfile: "",
    dynamic_offset: 0,
    dynamic_start: 0,
    dynamic_video_url: url,
    keywords: [],
    thirds: [],
    trace_numbers: [],
    home_team: null,
    away_team: null,
    spotlights: null,
    tags: [],
    sport_type: "soccer",
    parent_ref_id: null,
    meta: {},
    sources: null
  };
};

exports.createTempMomentForFileUpload = createTempMomentForFileUpload;